module.exports = __webpack_public_path__ + "img/card_sample1.1f5539c.png";